import type {ReactElement} from 'react';
import styles from './loadingSpinner.module.scss';

export default function LoadingSpinner(): ReactElement {
    return <div className={styles.spinner} />;
}
